import React, { useState, useContext, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { ObjModal } from '../../../../contexts';
import Rating from '@mui/material/Rating';


const Stars = ( { label, db, value, formId = 'gen' } ) => {
    const { setDraftValues } = useContext( ObjModal );
    const [ v, setV ] = useState( value );

    useEffect( () => {
        setV( value );
    }, [ value ] );

    const handleDraft = ( e, val ) => {
        setV( val );
        setDraftValues( prevState => (
            {
                ...prevState,
                [db]: val
            }
        ) );
    }

    return (
        <Col className='tf-obj-data-element'>
            <Form.Group as={Row} className='tf-form-group align-items-center py-1' controlId={`${formId}-${db}`}>
                <Form.Label column xs='auto' className='col-md-auto p-0 tf-form-label'>{label}</Form.Label>
                <Col className='me-1'>
                    <Rating id={`${formId}-${db}`} onChange={ handleDraft } value={ v ? v : 0 } precision={0.5} />
                </Col>
            </Form.Group>
        </Col>
    )
}

export default Stars;